"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isJamo_1 = __importDefault(require("./isJamo"));
function throwIfNotJamo(inputKey) {
    if (isJamo_1.default(inputKey))
        return;
    throw new Error(inputKey + " is not jamo");
}
exports.default = throwIfNotJamo;
